import React from 'react';

import { A11yWrapper } from 'components/a11y-wrapper';
import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants';

import { Total, TotalLabel, TotalsRow } from './styled';
import { RewardRow } from './subtotal.styled';
import { IRenderTotalsProps } from './types';

export const RenderTotals: React.FC<React.PropsWithChildren<IRenderTotalsProps>> = ({
  cart = {},
  otherDiscountAmount,
  rewardDiscount,
  isLoading,
}) => {
  const { subTotalCents = 0 } = cart;
  const { formatCurrencyForLocale } = useUIContext();
  const subtotal = Math.max(subTotalCents, 0);

  return (
    <>
      {!!rewardDiscount &&
        (isLoading ? (
          <CurrencyLineSkeleton />
        ) : (
          <RewardRow>
            <A11yWrapper>
              <TotalLabel color={primitive.$crunchyGreen}>{t('rewardSavings')}</TotalLabel>
            </A11yWrapper>
            <Total testID="reward-savings">
              <Currency
                prefix="- "
                amount={rewardDiscount}
                textProps={{ color: primitive.$crunchyGreen, fontSize: 'md' }}
              />
            </Total>
          </RewardRow>
        ))}
      {!!otherDiscountAmount &&
        (isLoading ? (
          <CurrencyLineSkeleton />
        ) : (
          <RewardRow>
            <A11yWrapper>
              <TotalLabel color={primitive.$crunchyGreen}>{t('comboOfferSavings')}</TotalLabel>
            </A11yWrapper>
            <Total testID="discount-savings">
              <Currency
                prefix="- "
                amount={otherDiscountAmount}
                textProps={{ color: primitive.$crunchyGreen, fontSize: 'md' }}
              />
            </Total>
          </RewardRow>
        ))}

      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <TotalsRow
          accessible
          focusable
          accessibilityLabel={`${t('subtotal')}: ${formatCurrencyForLocale(subtotal)}`}
        >
          <TotalLabel focusable={false}>{t('subtotal')}</TotalLabel>
          <Total focusable={false} testID="subtotal">
            <Currency focusable={false} amount={subtotal} textProps={{ fontSize: 'md' }} />
          </Total>
        </TotalsRow>
      )}
    </>
  );
};

export default RenderTotals;
